require('./broadcastManagerService');
require('../../shared/dataTransformers/clockTimeTransformer');
require('./liveScoreFirebaseService')
require('../../fhApp/currentUser/currentUser');
require('../../shared/guidService')
require('./singularOverlayService');
require('./singularOverlaysFirebaseService');
require('./imageDialogController');
require('./broadcastManagerService');

"use strict";

export class WatermarkImages {
  constructor(obj) {
    this.leagueImages200x100 = (obj && obj.leagueImages200x100) || [];
    this.productImages200x100 = (obj && obj.productImages200x100) || [];
  }
}


angular.module('app.admin.broadcastManager.broadcastManagerController', [
  'app.admin.broadcastManager.broadcastManagerService',
  'app.shared.dataTransformers.clockTimeTransformer',
  'liveScoreFirebaseService',
  'app.admin.broadcastManager.singularOverlayService',
  'singularOverlaysFirebaseService',
  'app.currentUser',
  'app.shared.guidService'
])
  .controller('app.admin.broadcastManager.broadcastManagerController', [
    '$scope',
    '$stateParams',
    'app.admin.broadcastManager.broadcastManagerService',
    '$interval',
    'app.shared.dataTransformers.clockTimeTransformer',
    'PRODUCT',
    '$state',
    'FIREBASE_CREDS',
    'liveScoreFirebaseService',
    'app.admin.broadcastManager.singularOverlayService',
    'singularOverlaysFirebaseService',
    'currentUser',
    'app.shared.guidService',
    '$q',
    '$uibModal',
    function ($scope, $stateParams, broadcastManager, $interval, clockTimeTransformer, product, $state, fbCreds, liveScoreFb, singularOverlayService, singularFb, currentUser, guidService, $q, $uibModal) {
      let scoreboardClockInterval = null;
      let overlaysInterval = null;

      $scope.OVERLAY_MODIFIER_SCOREBAR_TEXT = 1;
      $scope.OVERLAY_MODIFIER_TEAM_TEXT = 2;

      $scope.scoreboardRef = null;
      $scope.livescoreDisabled = false;

      $scope.productId = product.Id;
      $scope.scoringProviderId = null;
      $scope.layouts = null;
      $scope.gameId = $stateParams.gameId;
      $scope.game = null;
      $scope.scoringProviders = null;
      $scope.isSaving = false;

      $scope.selectedStream = null;
      $scope.selectedSreamIndex = null;

      $scope.overlayModifiers = [];

      $scope.scoreboard = { time: '20:00', period: 'PRE', 'visScore': 0, 'homeScore': 0 };
      $scope.scoreboardOptions = {
        isScoreboardClockRunning: false,
        scoreboardPeriods: ['PRE', 'INT', '1st', '2nd', '3rd', 'OT', 'SO'],
        useLiveScoring: true
      };

      $scope.userOwnsScoreboard = false;
      $scope.scoreboardOwned = false;
      $scope.enablePowerPlayClock = false;

      $scope.currentUser = currentUser;

      const OVERLAY_TYPE_HEAD_TO_HEAD = "HEAD_TO_HEAD";
      const OVERLAY_TYPE_THREE_STARS = "THREE_STARS";
      const OVERLAY_TYPE_TEAM_LINEUP = "TEAM_LINEUPS";
      const OVERLAY_TYPE_TEAM_SCHEDULE = "TEAM_UPCOMING_SCHEDULE";
      const OVERLAY_TYPE_LEAGUE_SCHEDULE = "LEAGUE_UPCOMING_SCHEDULE";
      const OVERLAY_TYPE_UPCOMING_CALENDAR = "UPCOMING_CALENDAR";

      const OVERLAY_TYPE_MODIFIER_HEAD_TO_HEAD = "MODIFIER_HEAD_TO_HEAD";
      const OVERLAY_TYPE_MODIFIER_POWER_PLAY_EFFICIENCY_HOME = "MODIFIER_POWER_PLAY_EFFICIENCY_HOME";
      const OVERLAY_TYPE_MODIFIER_POWER_PLAY_EFFICIENCY_VISITOR = "MODIFIER_POWER_PLAY_EFFICIENCY_VISITOR";
      const OVERLAY_TYPE_MODIFIER_OVERALL_TEAM_RECORD = "MODIFIER_OVERALL_TEAM_RECORD";

      const CLEAR_OVERLAY_LOCK_AFTER_SECONDS = 10000;

      $scope.singularOverlaysLoaded = false;
      let overlayChangeCallback = null;
      let overlaysUnlockSubscription = null;
      $scope.streamId = null;
      $scope.adminControl = false;
      $scope.watermarkImages = [];
      $scope.sponsorImages = [];
      let imageModal = null;
      $scope.loading = false;

      let init = () => {
        // Setup for ownership of HockeyTV scoreboard
        if (sessionStorage.getItem("userUid") === null) {
          sessionStorage.userUid = guidService.newGuid();
        }

        broadcastManager.getLeagues()
          .then(function (response) {
            let data = response.data;
            if (data.error) {
              alert(data.error);
            } else {
              $scope.leagues = data;
            }
          });

        if ($scope.gameId) {
          // get the game
          broadcastManager.retrieveGame($scope.gameId)
            .then(function (response) {
              let data = response.data;
              if (data.error) {
                alert(data.error);
              } else {
                $scope.game = data;
                $scope.selectedLeague = $scope.game.ileagueid_fk;
                $scope.scoringProviderId = $scope.game.iscoringproviderid_fk;
                $scope.initializeGame();
              }
            }).then(function () {
              // get the teams for the league
              broadcastManager.getTeams($scope.game.ileagueid_fk)
                .then(function (response) {
                  if (response.data.error) {
                    alert(response.data.error);
                  } else {
                    $scope.teams = response.data;
                    let teamIds = $scope.teams.map(t => t.iteamid);
                    // Update the team selection based on the users access
                    if (teamIds.includes($scope.game.hometeam.iteamid)) {
                      $scope.selectedTeam = $scope.game.hometeam.iteamid;
                    } else if (teamIds.includes($scope.game.awayteam.iteamid)) {
                      $scope.selectedTeam = $scope.game.awayteam.iteamid;
                    }

                  }
                });
            }).then(function () {
              // get the games for the team
              broadcastManager.getGames($scope.game.hometeam.iteamid) // <team_id>
                .then(function (response) {
                  // let data = response.data;
                  if (response.data.error) {
                    alert(response.data.error);
                  } else {
                    $scope.games = response.data;
                    $scope.selectedGame = $scope.game.igameid;
                  }
                });
            });
        }

        broadcastManager.retrieveScoringProviders()
          .then(function (response) {
            let data = response.data;

            if (data.error) {
              alert(data.error);
            }
            else {
              $scope.scoringProviders = data;
            }
          });
      };

      let initScoreboard = () => {
        if ($scope.game && $scope.game.igameid) {
          if ($scope.game.iscoringproviderid === 0) {
            $scope.livescoreDisabled = false;
            // hook up to firebase
            if (!currentUser.jwt) {
              let jwtPromise = currentUser.getFbJwt($scope.game.igameid).then(function () {
                liveScoreFb.authenticate(fbCreds.livescore.firebaseUrl, fbCreds.livescore.firebaseApiKey, currentUser.jwt).then(function () {
                  $scope.scoreboardRef = liveScoreFb.getGameRef($scope.game.igameid);
                  $scope.watchFirebaseScoreboard();
                  // push up initial data to firebase so the node is populated
                  $scope.updateFbScoreboard();
                  liveScoreFb.setTime($scope.scoreboard.time);
                });
              }).catch(function (e) {
                $scope.livescoreDisabled = true;
                $scope.scoreboardOptions.useLiveScoring = false;
                alert(e.msg);
              });
            }
            else {
              $scope.scoreboardRef = liveScoreFb.getGameRef($scope.game.igameid);
              $scope.watchFirebaseScoreboard();
              // push up initial data to firebase so the node is populated
              $scope.updateFbScoreboard()
              liveScoreFb.setTime($scope.scoreboard.time);
            }
          }
          else if ($scope.game.iscoringproviderid && $scope.game.iscoringproviderid !== 0) {
            // disconnect from firebase
            if ($scope.scoreboardRef) {
              $scope.scoreboardRef.off();
            }
          }
        } else {
          $scope.userOwnsScoreboard = true; // nobody 'owns' control of the scoreboard
        }
      };

      $scope.watchFirebaseScoreboard = function () {
        $scope.scoreboardRef.on('value', function (snapshot) {
          let fbSb = snapshot.val();

          if (fbSb) {
            // Check if there is a value in the owner property and see if it's a different user
            if (fbSb.hasOwnProperty("owner")) {
              $scope.scoreboardOwned = true;
              $scope.userOwnsScoreboard = (fbSb.owner == sessionStorage.userUid);
              if (!$scope.userOwnsScoreboard && scoreboardClockInterval) {
                $scope.stopClock();
              }
            } else {
              $scope.userOwnsScoreboard = true; // really no owner
              $scope.scoreboardOwned = false;
            }

            if (fbSb.hasOwnProperty("running")) {
              $scope.scoreboardOptions.isScoreboardClockRunning = fbSb.running;
            }

            if (fbSb.hasOwnProperty("useLiveScoring")) {
              $scope.scoreboardOptions.useLiveScoring = fbSb.useLiveScoring;
            }

            if (fbSb.hasOwnProperty("time")) {
              $scope.scoreboard.time = fbSb.time;
            }

            if (fbSb.hasOwnProperty("homeScore") && fbSb.hasOwnProperty("visScore") && fbSb.hasOwnProperty("period")) {
              $scope.scoreboard.homeScore = fbSb.homeScore;
              $scope.scoreboard.visScore = fbSb.visScore;
              $scope.scoreboard.period = fbSb.period;
            }

          } else {
            console.warn("Missing scoreboard data in firebase node: ", fbSb);
            $scope.userOwnsScoreboard = true;
            $scope.scoreboardOwned = false;
          }

          setTimeout(() => { $scope.$apply(); }, 0);
        });
      };

      $scope.updateFbScoreboard = function () {
        let sbData = {
          homeScore: $scope.scoreboard.homeScore,
          period: $scope.scoreboard.period,
          visScore: $scope.scoreboard.visScore,
          owner: sessionStorage.getItem("userUid"),
          lastUpdated: Date.now()
        };

        liveScoreFb.update(sbData);
      }

      $scope.takeoverScoreboard = function () {
        let confirmed = confirm("The scoreboard is currently controlled by another user. Are you sure you want to takeover control?");
        if (confirmed === true) {
          let uuid = sessionStorage.getItem("userUid");
          if (!uuid) {
            sessionStorage.userUid = guidService.newGuid();
          }

          liveScoreFb.setOwner(sessionStorage.getItem("userUid"));
        }
      };

      $scope.loadTeams = function (league_id) {
        if (league_id != null) {
          broadcastManager.getTeams(league_id)
            .then(function (response) {
              let data = response.data;
              if (data.error) {
                alert(data.error);
              } else {
                $scope.teams = data;
              }
            });
        }
      };

      $scope.loadGames = function (team_id) {
        if (team_id != null) {
          broadcastManager.getGames(team_id)
            .then(function (response) {
              let data = response.data;
              if (data.error) {
                alert(data.error);
              } else {
                $scope.games = data;
              }
            });
        }
      };

      $scope.selectGame = (game_id) => {
        if (game_id != null) {
          broadcastManager.retrieveGame(game_id)
            .then(function (response) {
              if (response.data.error) {
                alert(response.data.error);
              } else {
                // If switching games and the scoreboard was already bound to a different game, unbind it
                if (game_id != $scope.game.igameid) {
                  if ($scope.scoreboardRef) {
                    $scope.scoreboardRef.off();
                    $scope.scoreboardRef = null;
                  }
                }

                const newUrl = window.location.href.replace(`gameId=${$scope.gameId}`, `gameId=${game_id}`)
                if (newUrl) {
                  window.history.pushState(null, null, newUrl);
                }
                $scope.gameId = game_id;
                $scope.game = response.data;
                $scope.initializeGame();
              }
            });
        }
      };

      $scope.playGame = () => {
        let params = {
          type: 'game',
          id: $scope.game.igameid,
          audio: null
        };

        if ($scope.game.pixellot_only) {
          params.audio = 4;
        }

        $state.go('app.play', params);
      };

      $scope.initializeGame = function () {
        $scope.scoreboard = $scope.game.scoreboard;
        $scope.scoreboard.period = $scope.game.scoreboard.strperiod;
        $scope.scoreboard.time = $scope.game.scoreboard.strtime;
        $scope.scoreboard.visScore = $scope.game.scoreboard.iawayscore;
        $scope.scoreboard.homeScore = $scope.game.scoreboard.ihomescore;

        $scope.scoreboardOptions.useLiveScoring = $scope.game.scoreboard.uselivescoring;

        initScoreboard();

        if ($scope.selectedSreamIndex) {
          $scope.onBroadcastSelect($scope.selectedSreamIndex);
        }

        if ($scope.game.use_singular_overlays) {
          singularFb.init(fbCreds.singular.firebaseUrl, fbCreds.singular.firebaseApiKey, $scope.currentUser.data, $scope.game.igameid).then(function () {
            broadcastManager.getLeagueWatermarkImages($scope.game.ileagueid_fk)
              .then((response) => {
                $scope.watermarkImages = new WatermarkImages(response.data);
              }, error => {
                alert("Failed to load watermark images. Please try again later.");
              });
          },
            error => {
              alert("There was an error connecting to Firebase. Please try again later.");
            }
          );
        }
      };

      $scope.onBroadcastSelect = (stream_idx) => {
        if (stream_idx) {
          // update the audio stream team id appropriately, default to home
          $scope.audioStreamTeamId = $scope.game.hometeam.iteamid;

          if (!$scope.game.use_singular_overlays) {
            $scope.selectedStream = $scope.game.overlays[stream_idx];
            $scope.selectedStreamIndex = stream_idx;
            $scope.streamId = $scope.selectedStream.iaudiostreamid_fk;
            if ($scope.streamId == 2) { // away
              $scope.audioStreamTeamId = $scope.game.awayteam.iteamid;
            }

            broadcastManager.retrieveLayouts($scope.gameId, $scope.game.overlays[stream_idx].iaudiostreamid_fk)
              .then(function (response) {
                let data = response.data;

                if (data.error) {
                  alert(data.error);
                }
                else {
                  let dt = new Date();
                  let ts = dt.getTime();
                  angular.forEach(data, function (item) {
                    item.overlayimageurl = item.overlayimageurl + "?" + ts;
                  });
                  $scope.layouts = data;

                  // update game data in case game overlays have been updated by modifiers
                  broadcastManager.retrieveGame($scope.gameId)
                    .then(function (response) {
                      let data = response.data;
                      if (data.error) {
                        alert(data.error);
                      } else {
                        $scope.game = data;
                        $scope.getOverlayModifiers(stream_idx);
                      }
                    });
                }
              });

            $scope.enablePowerPlayClock = $scope.game.overlays[stream_idx].enablepowerplayclock;

            $scope.setRefresh();
          }
          else {
            $scope.streamId = $scope.game.singular_overlays[stream_idx].audio_stream.AudioId;
            if ($scope.streamId == 2) { // away
              $scope.audioStreamTeamId = $scope.game.awayteam.iteamid;
            }

            broadcastManager.getTeamSponsorImages($scope.audioStreamTeamId)
              .then((response) => {
                $scope.sponsorImages = response.data;
                initializeSingularOverlayHandlers();
              });
          }
        }
      };

      $scope.getOverlayModifiers = (stream_idx) => {
        broadcastManager.getOverlayModifiers($scope.gameId, $scope.game.overlays[stream_idx].iaudiostreamid_fk).then(function (response) {
          $scope.overlayModifiers = [];

          if (response.data.error) {
            console.log("broadcast-manager.component.ts getOverlayModifiers() - Failed to change get modifiers");
            alert("There was an error loading overlay modifiers");
          }
          else {
            for (let modifier of response.data) {
              modifier.selected = false;
              if ($scope.game.overlays[$scope.game.overlays[stream_idx].iaudiostreamid_fk - 1].scorebartextmodifierid) {
                if (modifier.modifier_type === $scope.OVERLAY_MODIFIER_SCOREBAR_TEXT && $scope.game.overlays[$scope.game.overlays[stream_idx].iaudiostreamid_fk - 1].scorebartextmodifierid === modifier.id) {
                  modifier.selected = true;
                }
              }
              if ($scope.game.overlays[$scope.game.overlays[stream_idx].iaudiostreamid_fk - 1].teamtextmodifierid) {
                if (modifier.modifier_type === $scope.OVERLAY_MODIFIER_TEAM_TEXT && $scope.game.overlays[$scope.game.overlays[stream_idx].iaudiostreamid_fk - 1].teamtextmodifierid === modifier.id) {
                  modifier.selected = true;
                }
              }

              $scope.overlayModifiers.push(modifier);
            }
          }
        });
      };

      $scope.toggleOverlayModifier = (modifier) => {
        if (!$scope.isSaving && $scope.game && $scope.selectedStream) {
          $scope.isSaving = true;
          modifier.isOn = !modifier.selected;

          broadcastManager.setGameStreamOverlayModifier($scope.gameId, $scope.game.overlays[$scope.selectedSreamIndex].iaudiostreamid_fk, modifier)
            .then((response) => {
              $scope.isSaving = false;
              if (response.data.error) {
                console.log("broadcast-manager.component.ts toggleOverlayModifier() - Failed to change overlay modifier", error);
                alert("There was an error changing the overlay modifier");
              }
              else {
                let overlay = response.data;
                //If turning on modifier, turn off the others of the same modifier type
                if (modifier.isOn) {
                  for (let om of $scope.overlayModifiers) {
                    if (modifier.modifier_type === om.modifier_type) {
                      om.selected = false;
                    }
                  }

                }
                modifier.selected = (modifier.modifier_type === $scope.OVERLAY_MODIFIER_SCOREBAR_TEXT && overlay.scorebartextmodifierid !== null || modifier.modifier_type === $scope.OVERLAY_MODIFIER_TEAM_TEXT && overlay.teamtextmodifierid !== null);
              }
            });
        }
      };

      $scope.togglePowerPlayClock = () => {
        if (!$scope.isSaving && $scope.game && $scope.selectedStream) {
          $scope.isSaving = true;
          let powerPlayClockIsOn = !$scope.enablePowerPlayClock;
          broadcastManager.setGameStreamPowerPlayClock($scope.gameId, $scope.game.overlays[$scope.selectedSreamIndex].iaudiostreamid_fk, powerPlayClockIsOn)
            .then((response) => {
              $scope.isSaving = false;
              if (response.data.error) {
                let errorMessage = 'Failed to change PowerPlay Clock: ' + response.data.error;
                console.log("broadcast-manager.component.ts togglePowerPlayClock() - " + errorMessage);
                alert(errorMessage);
              } else {
                // Update the enablePowerPlayClock value with whatever it's opposite is since the
                // API request was successful
                $scope.enablePowerPlayClock = !$scope.enablePowerPlayClock;
              }
            });
        }
      }

      $scope.toggleClassSelected = function (layout) {
        if (layout.active) {
          return 'btn btn-primary'
        } else {
          return 'btn btn--unselected'
        }
      };

      $scope.backgroundSelected = function (layout) {
        if (layout.active) {
          return 'background--active'
        }
      };

      $scope.toggleActive = function (layout_id, enable, sponsor_id) {
        layout_id = parseInt(layout_id);

        if ($scope.game && $scope.selectedStream) {
          let selectedStreamiOverlayFormat = $scope.selectedStream.ioverlayformatid_fk;
          $scope.selectedStream.ioverlayformatid_fk = layout_id;

          broadcastManager.toggleOverlay($scope.game, $scope.selectedStream, enable, sponsor_id)
            .then((response) => {
              let data = response.data;
              if (data.error) {
                $scope.selectedStream.ioverlayformatid_fk = selectedStreamiOverlayFormat;
                alert(data.error);
              }
              else {
                $scope.selectedStream = data;
              }
            });
        }
      };

      $scope.isOverlayOn = (layout_id, sponsor_id) => {
        if ($scope.game && $scope.selectedStream) {
          if ($scope.selectedStream.ioverlayformatid_fk === layout_id) {
            // If there is an overlay sponsor id, use that in the comparison
            if (sponsor_id) {
              if ($scope.selectedStream.ioverlaysponsorid === sponsor_id) {
                return !!$scope.selectedStream.ioverlayon;
              }
            } else {
              if (!$scope.selectedStream.ioverlaysponsorid) {
                return !!$scope.selectedStream.ioverlayon;
              }
            }
          }
        }
        return false;
      };

      $scope.saveProvider = function () {
        $scope.isSaving = true;
        broadcastManager.saveProvider($scope.game)
          .then(function (response) {
            let data = response.data;

            if (data.error) {
              alert(data.error);
            }
            else {
              $scope.game.overlay = data;
            }
            $scope.isSaving = false;
          });
      };

      $scope.startClock = () => {
        if (!$scope.scoreboardOwned) {
          liveScoreFb.setOwner(sessionStorage.getItem("userUid"));
        }
        scoreboardClockInterval = $interval(() => {
          let currentTime = clockTimeTransformer.stringToSeconds($scope.scoreboard.time);
          if (currentTime) {
            currentTime -= 1;
            $scope.scoreboard.time = clockTimeTransformer.secondsToString(currentTime, 'mm:ss');
          }
          // Check for ownership, as this could have changed from someone taking over the clock
          if ($scope.userOwnsScoreboard) {
            liveScoreFb.setTime($scope.scoreboard.time);
          }
        }, 1000);
        $scope.scoreboardOptions.isScoreboardClockRunning = true;
        liveScoreFb.setRunning($scope.scoreboardOptions.isScoreboardClockRunning);
      };

      $scope.stopClock = () => {
        $interval.cancel(scoreboardClockInterval);
        scoreboardClockInterval = null;
        $scope.scoreboardOptions.isScoreboardClockRunning = false;
        liveScoreFb.setRunning($scope.scoreboardOptions.isScoreboardClockRunning);
      };

      $scope.setClock = function () {
        if (!$scope.scoreboardOwned) {
          liveScoreFb.setOwner(sessionStorage.getItem("userUid"));
        }
        liveScoreFb.setTime($scope.scoreboard.time);
      }

      $scope.scoringProviderChanged = () => {
        if ($scope.scoreboardOptions.isScoreboardClockRunning) {
          $scope.stopClock();
        }

        if ($scope.game && $scope.selectedStream) {
          $scope.selectedStream.ioverlayformatid_fk = parseInt($scope.selectedStream.ioverlayformatid_fk);

          if ($scope.selectedStream.ioverlayformatid_fk === 0) {
            $scope.game.iscoringprovidergameid = $scope.game.igameid;
          }

          initScoreboard();

          $scope.setRefresh();
        }
      };

      $scope.publishScoreboard = () => {
        broadcastManager.publishScoreboard($scope.game.igameid, $scope.scoreboard);
      };

      /////// Singular Overlay Management

      let initializeSingularOverlayHandlers = function () {
        overlayChangeCallback = (data) => {
          if (data && data.gameId && data.gameId == $scope.game.igameid && data.audioId && data.audioId == $scope.streamId) {
            $scope.loading = true;

            // If overlays have not yet been loaded and the last forced update was more than 10 seconds ago force an update
            let currentDateTime = Date.now();
            if (!$scope.singularOverlaysLoaded) {
              if ((currentDateTime / 1000) - (data.forceSingularDataSync / 1000) > 10) {
                let fbParams = {
                  forceSingularDataSync: currentDateTime
                };
                singularFb.updateSingularOverlays($scope.game.igameid, $scope.streamId, fbParams);
              }

              // Setup a timeout function to enable overlays within X seconds if a callback from firebase doesn't happen
              overlaysUnlockSubscription = $interval(() => {
                $scope.loading = false;
                $interval.cancel(overlaysUnlockSubscription);
                overlaysUnlockSubscription = null;
              }, CLEAR_OVERLAY_LOCK_AFTER_SECONDS);

              $scope.overlayLayers = data.singularState;
              setTimeout(() => { $scope.$apply(); }, 0);
              $scope.singularOverlaysLoaded = true;
            } else {
              // Since overlays are now loaded we need to keep track of when changes are made and lock overlay changes during that
              // time and unlock them once the changes have been completed. Only update data when the lock has been lifted
              if (data.forceSingularDataSync <= data.previousSingularDataSync && data.lastOverlayLockTime <= data.lastOverlayUpdateTime) {
                $scope.loading = false;
                if (overlaysUnlockSubscription !== null) {
                  $interval.cancel(overlaysUnlockSubscription);
                }
                $scope.overlayLayers = data.singularState;
                setTimeout(() => { $scope.$apply(); }, 0);
              } else if (data.forceSingularDataSync > data.previousSingularDataSync || data.lastOverlayLockTime > data.lastOverlayUpdateTime) {
                $scope.loading = true;

                overlaysUnlockSubscription = $interval(() => {
                  $scope.loading = false;
                  $interval.cancel(overlaysUnlockSubscription);
                  overlaysUnlockSubscription = null;
                }, CLEAR_OVERLAY_LOCK_AFTER_SECONDS);
              }
            }
          }
        };

        singularFb.subscribeToSingularOverlays($scope.game.igameid, $scope.streamId, overlayChangeCallback);
      };

      let initiateOverlayToggle = function (gameId, audioStreamId, overlay, active) {
        let deferred = $q.defer();

        if (active && overlay && overlay.overlayType && overlay.overlayType !== '') {
          switch (overlay.overlayType) {
            case OVERLAY_TYPE_TEAM_LINEUP:
              singularOverlayService.bindOverlayTeamLineupData(gameId, audioStreamId).then(
                data => {
                  deferred.resolve(data);
                },
                error => {
                  deferred.reject(error);
                }
              );
              break;
            case OVERLAY_TYPE_TEAM_SCHEDULE:
              singularOverlayService.bindOverlayTeamScheduleData(gameId, audioStreamId, $scope.audioStreamTeamId, overlay.name).then(
                data => {
                  deferred.resolve(data);
                },
                error => {
                  deferred.reject(error);
                }
              );
              break;
            case OVERLAY_TYPE_LEAGUE_SCHEDULE:
              singularOverlayService.bindOverlayLeagueScheduleData(gameId, audioStreamId, overlay.name).then(
                data => {
                  deferred.resolve(data);
                },
                error => {
                  deferred.reject(error);
                }
              );
              break;
            case OVERLAY_TYPE_HEAD_TO_HEAD:
              singularOverlayService.bindOverlayHeadToHeadData(gameId, audioStreamId).then(
                data => {
                  deferred.resolve(data);
                },
                error => {
                  deferred.reject(error);
                }
              );
              break;
            case OVERLAY_TYPE_MODIFIER_HEAD_TO_HEAD:
              singularOverlayService.bindModifierHeadToHeadData(gameId, audioStreamId).then(
                data => {
                  deferred.resolve(data);
                },
                error => {
                  deferred.reject(error);
                }
              );
              break;
            case OVERLAY_TYPE_MODIFIER_POWER_PLAY_EFFICIENCY_HOME:
              singularOverlayService.bindModifierPowerPlayEfficiency(gameId, audioStreamId, true).then(
                data => {
                  deferred.resolve(data);
                },
                error => {
                  deferred.reject(error);
                }
              );
              break;
            case OVERLAY_TYPE_MODIFIER_POWER_PLAY_EFFICIENCY_VISITOR:
              singularOverlayService.bindModifierPowerPlayEfficiency(gameId, audioStreamId, false).then(
                data => {
                  deferred.resolve(data);
                },
                error => {
                  deferred.reject(error);
                }
              );
              break;
            case OVERLAY_TYPE_THREE_STARS:
              singularOverlayService.bindOverlayThreeStarsData(gameId, audioStreamId).then(
                data => {
                  deferred.resolve(data);
                },
                error => {
                  deferred.reject(error);
                });
              break;
            case OVERLAY_TYPE_UPCOMING_CALENDAR:
              singularOverlayService.bindOverlayUpcomingCalendarData(gameId, audioStreamId).then(
                data => {
                  deferred.resolve(data);
                },
                error => {
                  deferred.reject(error);
                });
              break;
            case OVERLAY_TYPE_MODIFIER_OVERALL_TEAM_RECORD:
              singularOverlayService.bindModifierOverallTeamRecord(gameId, audioStreamId).then(
                data => {
                  deferred.resolve(data);
                },
                error => {
                  deferred.reject(error);
                }
              );
              break;
            default:
              deferred.resolve(null);
          }
        } else {
          deferred.resolve(null);
        }

        return deferred.promise;
      };

      $scope.toggleOverlay = function (active, layerName, toggledOverlay) {
        setFbOverlayLockTime();
        let allOverlays = [toggledOverlay.name];

        // If we are turning on an overlay we need to also make sure to turn on all it's sub layers as well that are currently active
        if (active) {
          let layer = $scope.overlayLayers[layerName];
          if (layer) {
            for (const overlayKey in layer.subCompositions) {
              let overlay = layer.subCompositions[overlayKey];
              if (overlay.name === toggledOverlay.name) {
                for (const subLayerKey in overlay.subLayers) {
                  let subLayer = overlay.subLayers[subLayerKey];
                  for (const subOverlayKey in subLayer.subCompositions) {
                    let subOverlay = subLayer.subCompositions[subOverlayKey];
                    if (subOverlay.active) {
                      allOverlays.push(subOverlay.name);
                    }
                  }
                }
              }
            }
          }
        }

        initiateOverlayToggle($scope.gameId, $scope.streamId, toggledOverlay, active).then(_ => {
          singularOverlayService.toggleOverlays($scope.gameId, $scope.streamId, active, allOverlays).then(_ => {
            let layer = $scope.overlayLayers[layerName];
            if (layer) {
              for (const overlayKey in layer.subCompositions) {
                let overlay = layer.subCompositions[overlayKey];
                if (overlay.name === toggledOverlay.name) {
                  overlay.active = active;
                } else {
                  overlay.active = false;
                }
              }
            }
            updateFbSingularState();
            singularFb.logUserAction($scope.gameId, "Changing overlay " + layerName + "/" + toggledOverlay.name + " active state to " + active, "broadcastManagerController::toggleOverlay");
          },
            error => {
              alert("There was an error toggling the overlay. Please try again later.");
            }
          );
        })
      };

      $scope.toggleSubOverlay = function (parentLayerActive, active, layerName, overlayName, subLayerName, toggledOverlay) {
        setFbOverlayLockTime();
        if (!parentLayerActive) {
          updateSubOverlayState(active, layerName, overlayName, subLayerName, toggledOverlay.name);
          updateFbSingularState();
          singularFb.logUserAction($scope.game.igameid, "Changing sub overlay " + layerName + "/" + overlayName + "/" + subLayerName + "/" + toggledOverlay.name + " active state to " + active, "broadcastManagerController::toggleSubOverlay");
          return;
        }

        initiateOverlayToggle($scope.game.igameid, $scope.streamId, toggledOverlay, active).then(_ => {
          singularOverlayService.toggleOverlays($scope.game.igameid, $scope.streamId, active, [toggledOverlay.name]).then(
            _ => {
              updateSubOverlayState(active, layerName, overlayName, subLayerName, toggledOverlay.name);
              updateFbSingularState();
              singularFb.logUserAction($scope.game.igameid, "Changing sub overlay " + layerName + "/" + overlayName + "/" + subLayerName + "/" + toggledOverlay.name + " active state to " + active, "broadcastManagerController::toggleSubOverlay");
            },
            error => {
              alert("There was an error toggling the overlay. Please try again later.");
            }
          );
        }).catch(err => console.log("There was an error initiating overlay toggle. Please try again later."));
      };

      let updateSubOverlayState = function (active, layerName, overlayName, subLayerName, subOverlayName) {
        if ($scope.overlayLayers[layerName]) {
          for (const overlayKey in $scope.overlayLayers[layerName].subCompositions) {
            let overlay = $scope.overlayLayers[layerName].subCompositions[overlayKey];
            if (overlay.name === overlayName) {
              let subLayer = overlay.subLayers[subLayerName];
              if (subLayer) {
                for (const subLayerKey in subLayer.subCompositions) {
                  let subOverlay = subLayer.subCompositions[subLayerKey];
                  if (subOverlay.name === subOverlayName) {
                    subOverlay.active = active;
                  } else {
                    subOverlay.active = false;
                  }
                };
              }
            }
          };
        }
      };

      let setFbOverlayLockTime = function () {
        if ($scope.game.igameid && $scope.streamId) {
          $scope.loading = true;
          const fbParams = {
            lastOverlayLockTime: Date.now(),
          }
          singularFb.updateSingularOverlays($scope.game.igameid, $scope.streamId, fbParams);
        }
      }

      let updateFbSingularState = function () {
        if ($scope.game.igameid && $scope.streamId) {
          const fbParams = {
            lastOverlayUpdateTime: Date.now(),
            singularState: $scope.overlayLayers,
          }
          singularFb.updateSingularOverlays($scope.gameId, $scope.streamId, fbParams);
        }
      };

      $scope.allowPowerPlayChange = function (layerName, overlayName, overlayProperty, allowPowerPlay) {
        setFbOverlayLockTime();
        singularOverlayService.updateOverlay($scope.game.igameid, $scope.streamId, overlayName, overlayProperty.key, allowPowerPlay.toString()).then(
          _ => {
            $scope.overlayLayers[layerName]['subCompositions'][overlayName]['allowPowerPlay']['value'] = allowPowerPlay.toString();
            updateFbSingularState();
          },
          error => {
            alert("There was an error updating the overlay. Please try again later.");
          }
        );
      };

      let modalOpen = function (overlayName, overlayProperty, images) {
        imageModal = $uibModal.open({
          template: `<div class="imagesContainer">
                        <div class="topModal">
                          <h2>Select an Image</h2>
                          <button class="imageButton" ng-click="$ctrl.selectImage('')">Remove Image</button>
                        </div>
                        <div class="imagesBlock">
                            <div ng-repeat="image in $ctrl.images track by $index">
                                <div class="imageBlock">
                                    <a ng-click="$ctrl.selectImage(image)"><img ng-src={{image}} alt="Image"></a>
                                </div>
                            </div>
                        </div>
                      </div>`,
          controller: "imageDialogController",
          controllerAs: '$ctrl',
          windowClass: 'overlays-image-modal',
          resolve: {
            images: function () {
              return images;
            }
          }
        }).result.then(function (result) {
          if (result != null) {
            setFbOverlayLockTime();
            singularOverlayService.updateOverlay($scope.game.igameid, $scope.streamId, overlayName, overlayProperty.key, result).then(
              data => {
                overlayProperty.value = result;
                updateFbSingularState();
                singularFb.logUserAction($scope.game.igameid, "Changing overlay " + overlayName + " image value " + overlayProperty.key + "=" + overlayProperty.value, "broadcastManagerController::changeImageDialog");
              },
              error => {
                alert("There was an error updating the overlay. Please try again later.");
              }
            );
          }
        });
      };

      $scope.changeImageDialog = function (overlayName, overlayProperty, images) {
        modalOpen(overlayName, overlayProperty, images);
      };

      /////// End of Singular Overlay Management

      $scope.$on('$destroy', () => {
        if ($scope.scoreboardOptions.isScoreboardClockRunning) {
          $scope.stopClock();
        }
        if (scoreboardClockInterval) {
          $interval.cancel(scoreboardClockInterval);
        }
        if (overlaysInterval) {
          $interval.cancel(overlaysInterval);
        }

        // terminate firebase listener
        if ($scope.scoreboardRef) {
          $scope.scoreboardRef.off();
        }

        if (overlayChangeCallback !== null) {
          singularFb.unsubscribeFromSingularOverlays($scope.game.igameid, $scope.streamId, overlayChangeCallback);
        }

        // liveScoreFb.signOut();
      });

      $scope.setRefresh = () => {
        if (overlaysInterval) {
          $interval.cancel(overlaysInterval);
        }

        // We want to periodically refresh the game/overlay info so that if multiple people
        // are in broadcast manager, they're seeing changes made by others. However, this
        // should not be done if it's the HockeyTV scoring provider, as that resets the
        // manually managed scoreboard
        if ($scope.game.iscoringproviderid !== 0) {
          overlaysInterval = $interval(() => {
            $scope.selectGame($scope.game.igameid);
          }, 30000);
        }
      };

      $scope.$watch(
        () => {
          return $scope.scoreboardOptions.useLiveScoring;
        },
        () => {
          if ($scope.scoreboardOptions.useLiveScoring) {
            initScoreboard();
            if ($scope.scoreboardRef) {
              liveScoreFb.setUseLiveScore(true);
            }
          }
          else {
            if ($scope.scoreboardOptions.isScoreboardClockRunning) {
              $scope.stopClock();
            }
            if ($scope.scoreboardRef) {
              liveScoreFb.setUseLiveScore(false);
            }
          }

          if ($scope.game) {
            broadcastManager.toggleLiveScoring($scope.game.igameid, $scope.scoreboardOptions.useLiveScoring)
              .then((response) => {
                let data = response.data;

                if (data.error) {
                  alert(data.error);
                }
                else {
                  $scope.scoreboard = data;
                }
              })
          }
        }
      );

      init();
    }
  ]
  );


// WEBPACK FOOTER //
// ./app.v2/components/admin/broadcastManager/broadcastManagerController.js